module.exports = __webpack_public_path__ + "static/media/ic_disabled.8f7cdd48.svg";